<script setup>
import { useI18n } from "vue-i18n";
// Components
import Icon from "@/Components/Icon.vue";

// Icons
import userSit from "@i/user-sit.svg";
import userFly from "@i/user-fly.svg";
import book from "@i/book.svg";
import connection from "@i/connection.svg";
import roundStar from "@i/round-star.svg";
const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="container mx-auto px-0">
        <div class="grid md:grid-cols-2 items-stretch">
          <!-- Left Side: Full Image -->
          <div class="w-full h-full">
            <img
              src="@/../img/home/puzzle-hands.jpg"
              alt="Wandelpad"
              class="w-full h-full object-cover"
            />
          </div>

          <!-- Right Side: Content with Icons -->
          <div class="bg-white p-12 flex flex-col justify-center">
            <h2 class="text-4xl mb-4">{{ t("Ons Aanbod") }}</h2>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Box 1 -->
              <div class="items-start space-x-4">
                <Icon :icon="roundStar" class="w-10 ml-4 mb-4" />
                <div>
                  <h3 class="text-xl font-semibold">{{ t("Erkende Zorgopleidingen") }}</h3>
                  <p
                    class="text-sm"
                  >{{ t("Kwalificaties en certificaten voor de hoogste zorgstandaarden.") }}</p>
                </div>
              </div>

              <!-- Box 2 -->
              <div class="items-start space-x-4">
                <Icon :icon="connection" class="w-10 ml-4 mb-5" />
                <div>
                  <h3 class="text-xl font-semibold">{{ t("Specialistische Trainingen") }}</h3>
                  <p
                    class="text-sm"
                  >{{ t("Ontwikkeling gericht op mentale veerkracht, communicatie en samenwerking.") }}</p>
                </div>
              </div>

              <!-- Box 3 -->
              <div class="items-start space-x-4">
                <Icon :icon="userFly" class="w-10 ml-4 mb-5" />
                <div>
                  <h3 class="text-xl font-semibold">{{ t("Carrière") }}</h3>
                  <p
                    class="text-sm"
                  >{{ t("We helpen je bij het ontwikkelen van jouw carrière in de zorg. Ontdek nieuwe mogelijkheden, verdiep je expertise en bereik je doelen.") }}</p>
                </div>
              </div>

              <!-- Box 4 -->
              <div class="items-start space-x-4">
                <Icon :icon="book" class="w-10 ml-4 mb-5" />
                <div>
                  <h3 class="text-xl font-semibold">{{ t("Maatwerk Voor Organisaties") }}</h3>
                  <p
                    class="text-sm"
                  >{{ t("Speciaal afgestemde trajecten voor teams en afdelingen.") }}</p>
                </div>
              </div>

              <!-- Box 5 -->
              <div class="items-start space-x-4">
                <Icon :icon="userSit" class="w-10 ml-4 mb-5" />
                <div>
                  <h3 class="text-xl font-semibold">{{ t("Leiderschap") }}</h3>
                  <p
                    class="text-sm"
                  >{{ t("Sterk en inspirerend leiderschap is essentieel in de zorg. Onze trainingen helpen je bij het ontwikkelen van strategisch inzicht, besluitvaardigheid en effectieve teamsturing. Groei als leider en maak het verschil.") }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>